<template>
  <div class="filters">
    <div id="appa">
      <el-button class="carNumBtn">车牌号码 : </el-button>
      <el-select class="citySelect fs-20 mt-5" v-model="cityValue">
        <el-option v-for="item in cityList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-input class="carNum" v-model="carNum" placeholder='请输入车牌号码'></el-input>
      <!-- <div @click="soft" class="keyboard">
        <LicenseKeyboard ref="LicenseKeyboard" class="license-keyboard" v-model="carNum1" />
      </div> -->
      <div class="searchBtn">
        <el-button type="primary" @click="search">查询</el-button>
      </div>
      <div class="payRecord">
        <el-button type="primary" @click="toggle();record()">已发放记录</el-button>
      </div>
    </div>
    <div class="carinfo" v-if="orderData.length>0&&showSearch">
      <div class="carRow">
        <viewer :images="this.orderData">
          <img v-if="orderData.length>0" :src="orderData[0].InImagePath" />
        </viewer>
      </div>
      <div class="carRow">
        <span class="rowLabel">订单号：</span>
        <span>{{orderData[0].OrderId}}</span>
      </div>
      <div class="carRow">
        <span class="rowLabel">停车场：</span>
        <span>{{orderData[0].ParkName}}</span>
      </div>
      <div class="carRow">
        <span class="rowLabel">入场时间：</span>
        <span>{{inTime}}</span>
      </div>
      <div class="carRow">
        <span class="rowLabel">时长：</span>
        <span>{{duration}}</span>
      </div>
      <div class="carRow">
        <span class="rowLabel">本月额度：</span>
        <span class="bold">{{orderData[0].AllCount}}次</span>
      </div>
      <div class="carRow">
        <span class="rowLabel">减免时长：</span>
        <span class="bold">{{orderData[0].Cost6}}分钟</span>
      </div>
       <div class="carRow">
        <span class="rowLabel">已使用：</span>
        <span class="bold">{{orderData[0].UseCount}}次</span>
      </div>
      <div class="carRow">
        <span class="rowLabel">使用次数：</span>
        <el-input-number v-model.number="useCount" size="small" controls-position="right" :min="1" :max="999"></el-input-number>
      </div>
      <div class="payBtn" v-if="orderData[0].AllCount > orderData[0].UseCount">
        <p @click="pay">发放优惠</p>
      </div>
    </div>
    <div class="recordList" v-if="showRecord">
      <el-table :data="orderList" class="wid100" :row-class-name="tableRowClassName"
        :height="orderList.length > 0 ? require('@/config/enum').tableheight530 : require('@/config/enum').tableheight109">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="OrderId" label="订单号">
        </el-table-column>
        <el-table-column prop="CarNum" label="车牌号码">
        </el-table-column>
        <el-table-column prop="InTime" label="入场时间">
        </el-table-column>
        <el-table-column prop="CidtTime" label="优惠发放时间">
        </el-table-column>
         <el-table-column prop="UseCount" label="使用次数">
        </el-table-column>
        <!-- <el-table-column prop="PaySuccessTime" label="缴费时间">
        </el-table-column>
        <el-table-column prop="duration" label="停车时长">
        </el-table-column>
        <el-table-column prop="OrderAmount" label="缴费金额(元)">
        </el-table-column> -->
        <el-table-column prop="ParkName" label="停车场">
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        pageCount: 0, // 总数
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        carNum: 'A', //车牌号(数字部分)
        carNum1: '', //键盘车牌号(完整)
        gardenId: this.$store.getters.gardenId, //gardenId
        orderData: [], //停车信息
        inTime: '', //入场时间
        cidtTime: '', //入场时间
        userCount: '',
        duration: '', //停车时长
        orderList: [], //缴费记录列表
        showRecord: true, //缴费记录显示状态
        showSearch: false, //缴费信息显示状态
        useCount: 1,
        cityList: [{
            value: '辽',
            label: '辽'
          },
          {
            value: '吉',
            label: '吉'
          },
          {
            value: '黑',
            label: '黑'
          },
          {
            value: '蒙',
            label: '蒙'
          },
          {
            value: '京',
            label: '京'
          },
          {
            value: '津',
            label: '津'
          },
          {
            value: '冀',
            label: '冀'
          },
          {
            value: '沪',
            label: '沪'
          },
          {
            value: '渝',
            label: '渝'
          },
          {
            value: '豫',
            label: '豫'
          },
          {
            value: '云',
            label: '云'
          },
          {
            value: '湘',
            label: '湘'
          },
          {
            value: '鲁',
            label: '鲁'
          },
          {
            value: '新',
            label: '新'
          },
          {
            value: '苏',
            label: '苏'
          },
          {
            value: '浙',
            label: '浙'
          },
          {
            value: '赣',
            label: '赣'
          },
          {
            value: '鄂',
            label: '鄂'
          },
          {
            value: '桂',
            label: '桂'
          },
          {
            value: '甘',
            label: '甘'
          },
          {
            value: '晋',
            label: '晋'
          },
          {
            value: '陕',
            label: '陕'
          },
          {
            value: '皖',
            label: '皖'
          },
          {
            value: '闽',
            label: '闽'
          },
          {
            value: '贵',
            label: '贵'
          },
          {
            value: '青',
            label: '青'
          },
          {
            value: '粤',
            label: '粤'
          },
          {
            value: '藏',
            label: '藏'
          },
          {
            value: '川',
            label: '川'
          },
          {
            value: '宁',
            label: '宁'
          },
          {
            value: '琼',
            label: '琼'
          },
          {
            value: '使',
            label: '使'
          },
          {
            value: '领',
            label: '领'
          }
        ], //城市列表
        cityValue: '云', //选择的城市值
        newCarNum: '', //车牌号(拼接省份代码，完整的车牌号)
      }
    },
    computed: {

    },
    methods: {
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.record()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.record()
      },
      init() {
        this.$refs.LicenseKeyboard.init();
      },
      soft() {
        // this.showRecord = false
      },
      // 车辆入场信息查询接口
      search() {
        this.showSearch = true
        this.orderData = []
        this.newCarNum = this.cityValue + this.carNum
        let reg =
          /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DABCEFGHJK])|([DABCEFGHJK]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/;
        let isCarNum = reg.test(this.newCarNum)
        if (this.carNum == '') {
          this.$message.error('请输入车牌号码')
          this.showRecord = true
        } else {
          if (isCarNum) {
            this.showRecord = false
            let loading = this.$loading()
            let params = {
              carNum: this.newCarNum,
              gardenId: this.gardenId
            }
            console.log(params)
            this.$post(`/zljCar/searchPayOrderDerate`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  console.log(res)
                  if (res.OrderData) {
                    this.orderData = res.OrderData
                    let inTime = res.OrderData[0].InTime
                    let time = new Date(inTime);
                    let y = time.getFullYear();
                    let m = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
                    let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                    let h = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
                    let mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
                    let s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
                    let a = y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + s;
                    this.inTime = a                    

                    let nowTime = Date.parse(new Date());
                    let times = nowTime - inTime
                    let days = parseInt(times / (1000 * 60 * 60 * 24));
                    let hours = parseInt((times % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    let minutes = parseInt((times % (1000 * 60 * 60)) / (1000 * 60));
                    let duration;
                    if (days > 0) {
                      duration = days + " 天 " + hours + " 小时 " + minutes + " 分钟 "
                    } else if (days == 0 && hours > 0) {
                      duration = hours + " 小时 " + minutes + " 分钟 "
                    } else if (hours == 0 && minutes > 0) {
                      duration = minutes + " 分钟 "
                    }
                    this.duration = duration
                    // 缓存车牌归属地
                    this.$store.commit('car/setCityValue', this.cityValue)
                    this.$store.commit('car/setCarNum', this.carNum.substr(0,1))
                  } else {
                    this.$message.warning('暂无停车缴费信息')
                  }
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            this.$message.error('请输入正确车牌号码')
            this.showRecord = true
          }
        }

      },
      // 支付
      pay() {
        let loading = this.$loading()
        this.$confirm('是否发放优惠？', this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          })
          .then(() => {
            if (this.useCount == null || this.useCount < 1) {
              this.$message.error('请填写使用次数。')
              loading.close()
              return
            }
            let params = {
              orderId: this.orderData[0].OrderId,
              parkId: this.orderData[0].ParkId,
              gardenId: this.orderData[0].GardenId,
              useCount: this.useCount
            }
            console.log(params)
            this.$post(`/zljCar/payOrderDerate`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  console.log(res)
                  this.$message.success('发放优惠成功')
                  this.showSearch = false
                  this.showRecord = true
                  this.record()
                  this.carNum = ''
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_pay_can')
            })
          })
      },
      toggle() {
        this.showRecord = !this.showRecord
      },
      // 缴费记录
      record() {
        this.showSearch = false
        if (this.showRecord) {
          let loading = this.$loading()
          let params = {
            gardenId: this.gardenId,
            pageNo: this.pageNo,
            pageSize: this.pageSize
          }
          this.$post(`/zljCar/payOrderDerateList`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                console.log(res)
                this.orderList = res.OrderData
                this.pageCount = res.pageCount
                for (let i = 0; i < this.orderList.length; i++) {
                  let InTime = this.formatTime(this.orderList[i].InTime, 'Y/M/D h:m:s')
                  let CidtTime = this.formatTime(this.orderList[i].CidtTime, 'Y/M/D h:m:s')
                  let PaySuccessTime = this.formatTime(this.orderList[i].PaySuccessTime, 'Y/M/D h:m:s')
                  let times = this.orderList[i].PaySuccessTime - this.orderList[i].InTime
                  let days = parseInt(times / (1000 * 60 * 60 * 24));
                  let hours = parseInt((times % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                  let minutes = parseInt((times % (1000 * 60 * 60)) / (1000 * 60));
                  let duration;
                  if (days > 0) {
                    duration = days + " 天 " + hours + " 小时 " + minutes + " 分钟 "
                  } else if (days == 0 && hours > 0) {
                    duration = hours + " 小时 " + minutes + " 分钟 "
                  } else if (hours == 0 && minutes > 0) {
                    duration = minutes + " 分钟 "
                  }
                  this.$set(this.orderList[i], 'OrderAmount', this.orderList[i].OrderAmount / 100)
                  this.$set(this.orderList[i], 'InTime', InTime)
                  this.$set(this.orderList[i], 'CidtTime', CidtTime)
                  this.$set(this.orderList[i], 'UseCount', this.orderList[i].UseCount)
                  this.$set(this.orderList[i], 'PaySuccessTime', PaySuccessTime)
                  this.$set(this.orderList[i], 'duration', duration)
                }

              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      },
      formatNumber(n) {
        n = n.toString()
        return n[1] ? n : '0' + n
      },
      formatTime(number, format) {
        if (number == null || number == '') {
          return ''
        }
        let that = this
        let formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
        let returnArr = [];
        let date = new Date(number);
        returnArr.push(date.getFullYear());
        returnArr.push(that.formatNumber(date.getMonth() + 1));
        returnArr.push(that.formatNumber(date.getDate()));
        returnArr.push(that.formatNumber(date.getHours()));
        returnArr.push(that.formatNumber(date.getMinutes()));
        returnArr.push(that.formatNumber(date.getSeconds()));
        for (let i in returnArr) {
          format = format.replace(formateArr[i], returnArr[i]);
        }
        return format;
      },
    },
    watch: {
      carNum1(val){
         let reg =
          /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DABCEFGHJK])|([DABCEFGHJK]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/;
        let isCarNum = reg.test(val)
        if (isCarNum) {
          this.cityValue = val.substr(0,1)
          this.carNum = val.substr(1,val.length)
        }else{
          this.$message.error('请输入正确车牌号码')
        }
     },
    },
    mounted() {
      let cityValue = this.$store.getters.cityValue
      let carNum = this.$store.getters.carNum
      if(cityValue){
        this.cityValue = cityValue
      }
      if(carNum){
        this.carNum = carNum
      }
      this.record()
    }
  }
</script>
<style lang="scss">
  #appa {
    display: flex;
    width: 100%;
    height: 100%;
    color: #00b1c3;
    font-size: 1.5rem;
    background-color: #fff;
    position: relative;
  }

  .searchBtn {
    flex: 1;
    margin-left: 30px;
  }

  .searchBtn .el-button,
  .payRecord .el-button {
    // width: 100px;
    // padding: 5px 0;
    line-height: 1;
    text-align: center;
    font-size: 18px;
    color: #fff;
    // background-color: #00b1c3;
    border-radius: 5px;
  }

  .payRecord {
    margin-left: 50px;
  }

  .carNum {
    display: inline-block;
    width: 300px !important;
    padding: 5px 10px !important;
    color: #00b1c3;
    font-size: 20px;
    border-radius: 5px;
  }

  .carNum::-webkit-input-placeholder {
    color: #c1c1c1;
  }

  .license-container {
    position: fixed !important;
    width: 60% !important;
    left: 22% !important;
    bottom: 12% !important;
  }

  .app-license-keyboard .license-container .license-buttons span[data-v-416a3150] {
    padding: 1.25rem 0 !important;
    margin: 0.5rem 0.25 !important;
  }

  .app-license-keyboard .license-container .license-bar[data-v-416a3150] {
    color: #3d51aa !important;
  }

  .carinfo {
    width: 30%;
    margin: 20px;
    font-size: 20px;
    // color: #00b1c3;
  }

  .carRow {
    margin: 5px 0;
  }

  .carRow .bold {
    font-weight: bold;
    color: #00b1c3;
  }

  .rowLabel {
    display: inline-block;
    width: 100px;
    margin-right: 10px;
    text-align: right;
  }

  .carRow img {
    width: 500px;
    height: 300px;
  }

  .payBtn {
    width: 100%;
    margin-left: 35%;
  }

  .payBtn p {
    width: 100px;
    padding: 5px 0;
    text-align: center;
    font-size: 1.2rem;
    color: #fff;
    background-color: #00b1c3;
  }

  .recordList {
    margin-top: 30px;
  }

  .recordList .el-table td,
  .recordList .el-table th {
    text-align: center;
  }

  .carNumBtn {
    font-size: 20px;
    border: none !important;
    padding: 0 !important;
  }

  .keyboard {
    font-size: 20px;
    margin-top: 10px;
    margin-left: -40px;
    color: #000;
    z-index: 1000;
  }

  .citySelect {
    width: 70px !important;
  }
  .mt-5{
    margin-top: 5px;
  }
  .fs-20 .el-input__inner{
    font-size: 20px;
  }
  // .app-license-keyboard .license-container .license-buttons span[data-v-416a3150]{
  //   border-color: #00b1c3 !important;
  //   color: #00b1c3 !important;
  // }
  // .app-license-keyboard .license-container .license-buttons span[data-v-416a3150]:hover{
  //   background-color: #00b1c3 !important;
  //   color: #fff !important;
  // }
  // .app-license-keyboard .license-container[data-v-416a3150]{
  //   box-shadow: 0 0.25rem 0.375rem 0 #00b1c3 !important;
  // }
</style>